import React, { Component } from 'react';
import API from '../../../utils/API';
import FieldModal from '../../modals/fieldModal';

class DeleteGraphModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            submitting: false,
            error: null
        };
    }

    deleteGraph = async () => {
        const { eventId, orgId, reportId, graphId } = this.props;
        this.setState({ submitting: true, error: null });

        try {
            const response = await API().patch(
                `/Organizations/${orgId}/events/${eventId}/viewReports/${reportId}`,
                { deleteGraphId: graphId }
            );

            if (response.data) {
                this.props.removeGraph(graphId);
                this.props.toggle();
            }
        } catch (error) {
            console.error('Error deleting graph:', error);
            this.setState({
                error: error.response?.data?.message || 'Failed to delete graph'
            });
        } finally {
            this.setState({ submitting: false });
        }
    };

    render() {
        const { isOpen, toggle } = this.props;
        const { submitting, error } = this.state;

        return (
            <div>
                <FieldModal
                    size="small"
                    isOpen={isOpen}
                    modalTitle="Delete Chart"
                    bodyHeaderText="Are you sure you want to delete this chart? This cannot be undone."
                    bodyDescription={error ? `Error: ${error}` : ""}
                    bodyContent={() => ''}
                    toggle={toggle}
                    actionButtonLabel={!submitting ? 'Delete' : 'Deleting...'}
                    actionButton={() => this.deleteGraph()}
                    actionButtonDisabled={submitting}
                    isDelete={true}
                />
            </div>
        );
    }
}

export default DeleteGraphModal;